import { render, staticRenderFns } from "./Responsibles.vue?vue&type=template&id=2ae9403a&"
import script from "./Responsibles.vue?vue&type=script&lang=js&"
export * from "./Responsibles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports